// gtag is initialized in <head />.
// Use it via window object.

import trackingAccounts from './_trackingAccounts';

export function initGtag() {
  // Other initialization is done in app/views/layouts/_gtag.js
  if (window.dataLayer && window.gon.user) {
    window.dataLayer.push({
      uid: window.gon.user.id,
    });
  }
}

export function gtagSetAnalyticsId() {
  const analyticsId = trackingAccounts.GOOGLE_ANALYTICS;
  if (window.gtag && analyticsId) {
    window.gtag('config', analyticsId, { 'send_page_view': false });
  }
}

export function gtagPageView() {
  if (!window.gtag) {
    console.warn('Google Tag (gtag) is not initialized');
    return;
  }
  const analyticsId = trackingAccounts.GOOGLE_ANALYTICS;
  if (analyticsId) {
    window.gtag('config', analyticsId, {
      page_title: document.querySelector('title') ? document.querySelector('title').text : '',
      page_path: window.location.pathname,
    });
  }
}
